import { FC, useEffect, useState } from "react";
import { Parameter } from "../../../types/Parameter";
import { PathItem } from "../../../types/PathItem";
import {
  ColumnDirective,
  ColumnsDirective,
  Edit,
  Grid,
  GridComponent,
  Resize,
} from "@syncfusion/ej2-react-grids";
import {
  NumericTextBoxComponent,
  TextBoxComponent,
} from "@syncfusion/ej2-react-inputs";
import {
  DateTimePickerComponent,
  Inject,
} from "@syncfusion/ej2-react-calendars";
import { CheckBoxComponent } from "@syncfusion/ej2-react-buttons";
import { DialogComponent } from "@syncfusion/ej2-react-popups";
import { Col, Container, Row } from "react-grid-system";
import {
  getDocuments,
  getOption,
  getOptions,
  getTemplateParameters,
} from "../../../services/ApiService";
import { useAuth } from "../../../utility/useAuth";
import { getPathItem } from "../../../utility/pathHelper";
import { LabelText } from "../CompleteJobModal/CompleteJobModal.styles";
import { DropDownListComponent } from "@syncfusion/ej2-react-dropdowns";
import {
  convertParamerType,
  updateMaxValues,
} from "../../../utility/parameterHelper";
import { useStoreState } from "../../../store";

interface IPrintLabelModal {
  open: boolean;
  jobNumber: string;
  onPrint: (
    template: PathItem,
    parameters: Parameter[],
    printAsPdf: boolean,
    printerLocation: string,
    printerName: string,
  ) => void;
  onClose: () => void;
}

export const PrintLabelModal: FC<IPrintLabelModal> = ({
  open,
  onPrint,
  onClose,
  jobNumber,
}) => {
  const [params, setParams] = useState<Parameter[]>([]);
  const [errors, setErrors] = useState("");
  const [templates, setTemplates] = useState<PathItem[]>([]);
  const [printLocations, setPrintLocations] = useState<string[]>([]);
  const [selectedPrinterLocation, setSelectedPrinterLocation] =
    useState<string>();
  const [printerName, setPrintName] = useState<string>();
  const [selectedTemplate, setSelectedTemplate] = useState<PathItem>();
  const [printAsPdf, setPrintAsPdf] = useState<boolean>(false);
  const user = useStoreState((state) => state.user);

  const auth = useAuth();

  useEffect(() => {
    getDocuments(auth, undefined, "templates-labelprinter", true).then(
      (documents) => {
        const templates = documents.map((document) => getPathItem(document));
        setTemplates(templates);
      },
    );

    getDocuments(auth, undefined, "print-locations", true).then((documents) => {
      const locations = documents.map(
        (document) => getPathItem(document).fileName,
      );
      setPrintLocations(locations);
      setSelectedPrinterLocation(user.info.printLocation);
      getOption(auth, `LabelPrinter:${user.info.printLocation}`).then(
        (option) => {
          setPrintName(option);
        },
      );
    });

    // getOptions(auth, "PrintLocation").then((printLocations) => {
    //   setPrintLocations(printLocations);
    // });
    if (params) {
      validate(params);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    validate(params);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTemplate, printAsPdf, selectedPrinterLocation, printerName]);

  const buttons = [
    {
      buttonModel: {
        content: "Print",
        cssClass: "e-flat",
        isPrimary: true,
        disabled:
          selectedTemplate &&
          selectedTemplate.fileName.length > 0 &&
          selectedPrinterLocation &&
          printerName &&
          params &&
          params.length > 0 &&
          (!errors || errors.length <= 0)
            ? false
            : true,
      },
      click: () => {
        if (selectedTemplate && params) {
          onPrint(
            selectedTemplate,
            params,
            printAsPdf,
            selectedPrinterLocation ?? "",
            printerName ?? "",
          );
        }
      },
    },
    {
      buttonModel: {
        content: "Cancel",
        cssClass: "e-flat",
      },
      click: () => {
        onClose();
      },
    },
  ];

  const firstPosition = { X: 400, Y: 0 };

  let grid: Grid | null;

  function onTemplateChange(args: any) {
    if (args) {
      const template = templates.find((t) => t.fileName === args.value);
      if (selectedTemplate?.fileName !== args.value && template) {
        setParams([]);
        getTemplateParameters(
          auth,
          template.folder,
          template.fileName,
          jobNumber,
        ).then((parameters) => {
          let params = parameters.map((param) => convertParamerType(param));
          params = updateMaxValues(params);
          console.log(`get template parameters: ${JSON.stringify(params)}`);
          setParams(params);
        });
      }

      setSelectedTemplate(template);
    }
  }

  function onLocationChange(args: any) {
    if (args) {
      setSelectedPrinterLocation(args.value);
      getOption(auth, `LabelPrinter:${args.value}`).then((option) => {
        setPrintName(option);
      });
    }
  }

  function onChangePrintAsPdf(args: any) {
    if (args) {
      setPrintAsPdf(args.target.checked);
    }
  }

  const validate = (parameters: Parameter[] | undefined) => {
    console.log(`onValidate  ${JSON.stringify(parameters)}`);

    let errors = "";

    setErrors("");

    if (!selectedTemplate) {
      errors += "Please select the template. ";
    }

    if (!printAsPdf && !selectedPrinterLocation) {
      errors += "Please select the Printer location. ";
    }

    if (!printAsPdf && !printerName) {
      errors += "The Printer name is not defined. ";
    }

    if (
      parameters?.some(
        (parameter) =>
          parameter.value === undefined || parameter.value === null,
      )
    ) {
      errors += "Please enter all parameters. ";
    }

    setErrors(errors);
  };

  const conditionTemplate = (props: any) => {
    return (
      <div>
        {props.type === "string" ? (
          <TextBoxComponent
            id="checkTest"
            disabled={props.isReadOnly}
            value={props.value}
            onChange={(args: any) => {
              const updatedItems = [
                ...params.map((parameter) => {
                  if (parameter.name === props.name) {
                    parameter.value = args.value;
                  }
                  return parameter;
                }),
              ];
              console.log(`onclicked  ${JSON.stringify(updatedItems)}`);
              validate(updatedItems);
              setParams(updatedItems);
            }}
          />
        ) : (
          <></>
        )}
        {props.type === "number" ? (
          <NumericTextBoxComponent
            id="numberTextBox"
            value={props.value}
            min={props.minValue}
            max={props.maxValue}
            disabled={props.isReadOnly}
            change={(args: any) => {
              console.log(`on Change  ${args.value} ${props.name} `);
              
              let updatedItems = [
                ...params.map((parameter) => {
                  if (parameter.name === props.name) {
                    parameter.value = args.value;
                  }
                  return parameter;
                }),
              ];
              updatedItems = updateMaxValues(updatedItems);
              console.log(`onclicked  ${JSON.stringify(updatedItems)}`);
              validate(updatedItems);
              setParams(updatedItems);
            }}
          />
        ) : (
          <></>
        )}
        {props.type === "dateTime" ? (
          <DateTimePickerComponent
            id="dateTime"
            value={props.value}
            disabled={props.isReadOnly}
            onChange={(args: any) => {
              const updatedItems = [
                ...params.map((parameter) => {
                  if (parameter.name === props.name) {
                    parameter.value = args.value;
                  }
                  return parameter;
                }),
              ];
              console.log(`onclicked  ${JSON.stringify(updatedItems)}`);
              validate(updatedItems);
              setParams(updatedItems);
            }}
          />
        ) : (
          <></>
        )}
        {props.type === "boolean" ? (
          <CheckBoxComponent
            id="checkTest"
            checked={props.value === true}
            disabled={props.isReadOnly}
            onChange={(args: any) => {
              const updatedItems = [
                ...params.map((parameter) => {
                  if (parameter.displayName === props.displayName) {
                    parameter.value = args.target.checked;
                  }
                  return parameter;
                }),
              ];
              console.log(`onclicked  ${JSON.stringify(updatedItems)}`);
              setParams(updatedItems);
            }}
          />
        ) : (
          <></>
        )}
      </div>
    );
  };

  return (
    <DialogComponent
      width="500px"
      close={onClose}
      header="Print Label"
      visible={open}
      showCloseIcon={true}
      buttons={buttons}
      position={firstPosition}
      isModal
    >
      <div className="dialogContent">
        <Container fluid>
          <Row align="stretch">
            <Col sm={4}>
              <LabelText>Template</LabelText>
            </Col>
            <Col>
              <DropDownListComponent
                id="ddlelement"
                dataSource={templates}
                fields={{ text: "fileName", value: "fileName" }}
                value={templates}
                placeholder="Select a template"
                onChange={onTemplateChange}
              />
            </Col>
          </Row>
          <Row align="stretch">
            <GridComponent
              dataSource={params}
              id="GridParameters"
              height={420}
              //allowPaging={true}
              allowResizing={true}
              gridLines="Both"
              ref={(g: GridComponent) => (grid = g)}
              //editSettings={editSettings}
              //load={load}
              //actionComplete={onActionComplete}
            >
              <ColumnsDirective>
                <ColumnDirective
                  field="displayName"
                  headerText="Info"
                  type="string"
                  isPrimaryKey={true}
                />
                <ColumnDirective
                  field="value"
                  headerText="Value"
                  template={conditionTemplate}
                />
              </ColumnsDirective>
              <Inject services={[Edit, Resize]} />
            </GridComponent>
          </Row>
          <Row align="stretch">
            <CheckBoxComponent
              label="Print As Pdf"
              checked={printAsPdf}
              onChange={onChangePrintAsPdf}
            />
          </Row>
          {!printAsPdf ? (
            <>
              <Row align="stretch">
                <Col sm={4}>
                  <LabelText>Printer Location</LabelText>
                </Col>
                <Col>
                  <DropDownListComponent
                    id="printLocElement"
                    dataSource={printLocations}
                    //fields={{ text: "fileName", value: "fileName" }}
                    value={selectedPrinterLocation}
                    placeholder="Select a printer location"
                    onChange={onLocationChange}
                  />
                </Col>
              </Row>
              <Row align="stretch">
                <Col sm={4}>
                  <LabelText>Printer Name</LabelText>
                </Col>
                <Col>
                  <TextBoxComponent value={printerName} disabled />
                </Col>
              </Row>
            </>
          ) : (
            <></>
          )}
          <Row align="stretch">
            <h6 style={{ color: "red" }}>{errors}</h6>
          </Row>
        </Container>
      </div>
    </DialogComponent>
  );
};
